import { googleCalendarConfig } from '../firebase/googleCalendarConfig';
import { firestore } from '../firebase/config';

// Initialiser l'API Google Calendar
export const initGoogleCalendarApi = () => {
  return new Promise((resolve, reject) => {
    window.gapi.load('client:auth2', () => {
      window.gapi.client.init(googleCalendarConfig)
        .then(resolve)
        .catch(reject);
    });
  });
};

// Authentifier le praticien avec Google
export const authenticateWithGoogle = async () => {
  const authInstance = window.gapi.auth2.getAuthInstance();
  const isSignedIn = authInstance.isSignedIn.get();
  
  if (!isSignedIn) {
    return authInstance.signIn();
  }
  
  return authInstance.currentUser.get();
};

// Créer un événement dans Google Calendar
export const createGoogleCalendarEvent = async (appointment, practitioner) => {
  const calendarId = practitioner.googleCalendarId;
  
  const event = {
    summary: `RDV: ${appointment.serviceTitle} - ${appointment.name}`,
    location: '25 rue des Plantes, 75014 Paris',
    description: `Client: ${appointment.name}\nTéléphone: ${appointment.phone}\nEmail: ${appointment.email}\nNotes: ${appointment.message || 'Aucune'}`,
    start: {
      dateTime: `${appointment.date}T${appointment.time}:00`,
      timeZone: 'Europe/Paris'
    },
    end: {
      dateTime: calculateEndTime(appointment.date, appointment.time, appointment.duration),
      timeZone: 'Europe/Paris'
    },
    reminders: {
      useDefault: false,
      overrides: [
        { method: 'email', minutes: 24 * 60 },
        { method: 'popup', minutes: 60 }
      ]
    }
  };
  
  try {
    const response = await window.gapi.client.calendar.events.insert({
      calendarId: calendarId,
      resource: event
    });
    
    // Mettre à jour l'ID de l'événement dans Firestore
    await firestore.collection('appointments').doc(appointment.id).update({
      googleEventId: response.result.id
    });
    
    return response.result;
  } catch (error) {
    console.error('Erreur lors de la création de l\'événement Google Calendar:', error);
    throw error;
  }
};

// Supprimer un événement dans Google Calendar
export const deleteGoogleCalendarEvent = async (appointment, practitioner) => {
  if (!appointment.googleEventId) return;
  
  try {
    await window.gapi.client.calendar.events.delete({
      calendarId: practitioner.googleCalendarId,
      eventId: appointment.googleEventId
    });
  } catch (error) {
    console.error('Erreur lors de la suppression de l\'événement Google Calendar:', error);
    throw error;
  }
};

// Calculer l'heure de fin en fonction de la durée
const calculateEndTime = (date, time, duration) => {
  const [hours, minutes] = time.split(':').map(Number);
  const endTime = new Date(`${date}T${time}:00`);
  endTime.setMinutes(endTime.getMinutes() + duration);
  
  return endTime.toISOString();
};